/* Clean search URLs: /search?q=... only (filters are kept). */
(() => {
  const drop = ['type', 'options', 'options[prefix]', 'options[unavailable_products]', 'options[fields]'];
  const clean = href => {
    const u = new URL(href, location.origin);
    drop.forEach(k => u.searchParams.delete(k));
    return u.pathname + u.search + u.hash;
  };
  const isSearch = u => { try { return new URL(u, location.origin).pathname.endsWith('/search'); } catch (e) { return false; } };
  document.addEventListener('submit', e => {
    const f = e.target;
    if (!f.matches || !f.matches('form[action]') || !isSearch(f.getAttribute('action'))) return;
    f.querySelectorAll('input[type="hidden"]').forEach(i => { if (drop.includes(i.name)) i.remove(); });
  }, true);
  document.addEventListener('click', e => {
    const a = e.target.closest && e.target.closest('a[href*="/search?"]');
    if (a) a.setAttribute('href', clean(a.href));
  }, true);
  if (isSearch(location.href) && drop.some(k => new URL(location.href).searchParams.has(k))) {
    history.replaceState(history.state, '', clean(location.href));
  }
})();
